require('./brokerMiFID2DisapprovedTestDisclaimerCC.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { ContentBox } = require('commonsComponents/contentBox');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');

class BrokerMiFID2DisapprovedTestDisclaimerCC extends React.Component {

    render() {
        const { immProfileFields, onContinueWithDisapprovedTest, onReviewDisapprovedTest } = this.props;
        const clientName = <span>{PersonalDataHelper.getFullName(immProfileFields, false)}</span>;

        return(
            <ContentBox
                customClassName="broker-disapproved-test-diclaimer-cc__content"
            >
                <div className="broker-disapproved-test-diclaimer-cc__title">
                    <FormattedText value="broker-convenienceMifidDisapproveCCTitle" />
                </div>
                <div className="broker-disapproved-test-diclaimer-cc__disclaimer">
                    <BlockInfo>
                        <p className="broker-disapproved-test-diclaimer-cc__paragraph">
                            <FormattedTextWithComponents
                            value="broker-convenienceMifidDisapproveCCContent1"
                            injectedComponents ={[
                                clientName
                            ]}
                        />
                        </p>
                        <p className="broker-disapproved-test-diclaimer-cc__paragraph">
                            <FormattedText value="broker-convenienceMifidDisapproveCCContent2" />
                        </p>
                        <p className="broker-disapproved-test-diclaimer-cc__paragraph">
                            <FormattedText value="broker-convenienceMifidDisapproveCCContent3" />
                        </p>
                    </BlockInfo>
                </div>
                <footer className="broker-disapproved-test-diclaimer-cc__footer text-right">
                    <div className="broker-disapproved-test-diclaimer-cc__continue-button-container">
                        <OKButton
                            modifier="ghost"
                            onClick={() => onContinueWithDisapprovedTest()}
                        >
                            <FormattedText value="broker-convenienceMifidDisapproveCCButtonContinue" />
                        </OKButton>
                    </div>
                    <div className="broker-disapproved-test-diclaimer-cc__review-button-container">
                        <OKButton
                            modifier="secondary"
                            onClick={() => onReviewDisapprovedTest()}
                        >
                            <FormattedText value="broker-convenienceMifidDisapproveCCButtonReview" />
                        </OKButton>
                    </div>
                </footer>
            </ContentBox>
        );
    }
}

BrokerMiFID2DisapprovedTestDisclaimerCC.propTypes = {
    immProfileFields: PropTypes.object,
    onContinueWithDisapprovedTest: PropTypes.func,
    onReviewDisapprovedTest: PropTypes.func,
};

module.exports = BrokerMiFID2DisapprovedTestDisclaimerCC;